import React from 'react'
import moment from 'moment'
import { SingleDatePicker } from 'react-dates'

class DatetimeField extends React.Component {

  state = {
    focused: false,
  }

  handleChange = (date) => {
    this.props.onChange(date.toDate())
  }

  render() {
    const { value } = this.props
    return (
      <SingleDatePicker
        date={value ? moment(value) : moment()}
        onDateChange={this.handleChange}
        focused={this.state.focused}
        onFocusChange={({ focused }) => this.setState({ focused })}
        id="your_unique_id"
      />
    )
  }

}

export default DatetimeField